"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CampaignTrackingParameterService = require("./CampaignTrackingParameterService");

var _CampaignTrackingParameterService2 = _interopRequireDefault(_CampaignTrackingParameterService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CampaignTrackingParameterService2.default;